// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"45d12965","805":"85c83f2f"}[chunkId] + ".chunk.css";
};